import { IWebchatChatSessionsRepository } from 'modules/webchat/domain/repositories';
import { makeStorageProvider } from 'shared/infra/providers';

import SessionStorageWebchatChatSessionsRepository from './implementations/SessionStorageWebchatChatSessionsRepository';

let instance: IWebchatChatSessionsRepository | null = null;

export default function makeWebchatChatSessionsRepository() {
  if (!instance) {
    instance = new SessionStorageWebchatChatSessionsRepository(
      makeStorageProvider({ type: 'SESSION' }),
    );
  }

  return instance;
}
